import { Component, Input, Output, EventEmitter, OnInit, OnChanges, SimpleChanges } from '@angular/core';

@Component({
  selector: 'app-duplicate-enquiry-result',
  templateUrl: './duplicate-enquiry-result.component.html',
  styleUrls: ['./duplicate-enquiry-result.component.scss']
})
export class DuplicateEnquiryResultComponent implements OnInit, OnChanges {
  @Input() isMobile: boolean = false;
  @Input() theme: string = 'silver';
  @Input() message: string = "";
  @Input() enquiryNo:string = "";

  @Output() closeDuplicateModal: EventEmitter<any> = new EventEmitter();
  @Output() openEnquiryInEdit: EventEmitter<any> = new EventEmitter();

  ngOnInit(): void {

  }

  ngOnChanges(changes: SimpleChanges): void {
    if (changes && changes["message"]){
      this.message = changes["message"].currentValue;
    }
  }


  /* EVENTS */
  onEditEnquiryClick(){
    this.openEnquiryInEdit.emit(this.enquiryNo);
  }

  onCloseDuplicateModalClick(){
    this.closeDuplicateModal.emit('');
  }
}
